import { gql, TypedDocumentNode } from '@apollo/client';

import { WorkOrderAssetTreeNode } from '@atom/components/common/workOrderDetail/workOrderAssetView/normalizeWorkOrderAssetTree';
import {
  WorkOrderAssetAttributeChangeInput,
  WorkOrderAssetChangesApprovalInput,
  WorkOrderAssetElementsCreateInput,
  WorkOrderAssetInput,
  WorkOrderAssetUpdateInput,
} from '@atom/types/work';

// `elements` and the groups' `elements` are AnyValue scalars: the tree is
// recursive, so nested nodes arrive in the work service's raw shape and the
// client normalizes them.
export const GET_WORK_ORDER_ASSET_TREE: TypedDocumentNode<
  { workOrderAssetTree: WorkOrderAssetTreeNode },
  { input: WorkOrderAssetInput }
> = gql`
  query workOrderAssetTree($input: WorkOrderAssetInput!) {
    workOrderAssetTree(input: $input) {
      id
      name
      assetType
      schemaId
      markerId
      isNew
      changeType
      includeChangesBefore
      attributes
      attributeGroups {
        id
        name
        expandByDefault
        attributes
      }
      elements
      elementGroups {
        id
        name
        elements
      }
    }
  }
`;

export const UPDATE_WORK_ORDER_ASSET: TypedDocumentNode<
  { workOrderAssetUpdate: boolean },
  { input: WorkOrderAssetUpdateInput }
> = gql`
  mutation workOrderAssetUpdate($input: WorkOrderAssetUpdateInput!) {
    workOrderAssetUpdate(input: $input)
  }
`;

export const DELETE_WORK_ORDER_ASSET: TypedDocumentNode<
  { workOrderAssetDelete: boolean },
  { input: WorkOrderAssetInput }
> = gql`
  mutation workOrderAssetDelete($input: WorkOrderAssetInput!) {
    workOrderAssetDelete(input: $input)
  }
`;

export const CREATE_WORK_ORDER_ASSET_ELEMENTS: TypedDocumentNode<
  { workOrderAssetElementsCreate: boolean },
  { input: WorkOrderAssetElementsCreateInput }
> = gql`
  mutation workOrderAssetElementsCreate(
    $input: WorkOrderAssetElementsCreateInput!
  ) {
    workOrderAssetElementsCreate(input: $input)
  }
`;

export const APPROVE_WORK_ORDER_ASSET_CHANGES: TypedDocumentNode<
  { workOrderAssetChangesApprove: boolean },
  { input: WorkOrderAssetChangesApprovalInput }
> = gql`
  mutation workOrderAssetChangesApprove(
    $input: WorkOrderAssetChangesApprovalInput!
  ) {
    workOrderAssetChangesApprove(input: $input)
  }
`;

export const REJECT_WORK_ORDER_ASSET_CHANGES: TypedDocumentNode<
  { workOrderAssetChangesReject: boolean },
  { input: WorkOrderAssetChangesApprovalInput }
> = gql`
  mutation workOrderAssetChangesReject(
    $input: WorkOrderAssetChangesApprovalInput!
  ) {
    workOrderAssetChangesReject(input: $input)
  }
`;

export const APPROVE_WORK_ORDER_ASSET_ATTRIBUTE_CHANGE: TypedDocumentNode<
  { workOrderAssetAttributeChangeApprove: boolean },
  { input: WorkOrderAssetAttributeChangeInput }
> = gql`
  mutation workOrderAssetAttributeChangeApprove(
    $input: WorkOrderAssetAttributeChangeInput!
  ) {
    workOrderAssetAttributeChangeApprove(input: $input)
  }
`;

export const REJECT_WORK_ORDER_ASSET_ATTRIBUTE_CHANGE: TypedDocumentNode<
  { workOrderAssetAttributeChangeReject: boolean },
  { input: WorkOrderAssetAttributeChangeInput }
> = gql`
  mutation workOrderAssetAttributeChangeReject(
    $input: WorkOrderAssetAttributeChangeInput!
  ) {
    workOrderAssetAttributeChangeReject(input: $input)
  }
`;
